export const mediaRoutes = {
  detail: {
    delete: (id: string) => `/media/${id}`,
    index: (id: string) => `/media/${id}`,
  },
  export: '/media/export',
  index: '/media',
  resource: ({ id }: { id: string }) => `/media/resource/${id}`,
  resourceVariant: ({ id, size, type }: { id: string; size: string; type: string }) =>
    `/media/resource/${size}/${type}/${id}`,
};
